const AUTH_FORBIDDEN = 0;
const AUTH_REQUIRED = 1;
const AUTH_OPTIONAL = 2;
/*:: type AuthType = 0 | 1 | 2;*/

const types = {
  AUTH_FORBIDDEN,
  AUTH_REQUIRED,
  AUTH_OPTIONAL
};
/**
 * Poly fill necessary because URL / URLSearchParams
 * are still a "living spec".
 *
 * https://github.com/github/fetch/issues/256
 *
 * @param  {[type]} url    [description]
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */

const withQuery = (url, params) => {
  const query = Object.keys(params).filter(k => params[k] !== undefined).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`).join('&');
  if (!query.length) return url;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + query;
};
/**
 * Encapsulates the raw data of an API request
 *
 * Allows for parsing & serialization customization on a per-request basis.
 *
 * TODO: Replace this with the `Request` object defined
 * in the fetch API directly if possible.
 */


const _parse = json => json; // eslint-disable-line no-underscore-dangle


const _serialize = data => data; // eslint-disable-line no-underscore-dangle


class Request {
  constructor(path
  /*: string*/
  , data
  /*: Object*/
  = {}, fields
  /*: string[]*/
  = [], transform
  /*: ?Function*/
  , useCursor
  /*: ?Boolean*/
  ) {
    this.path = path;
    this.method = null;
    this.data = data;
    this.fields = fields;
    this.transform = transform;
    this.useCursor = useCursor; // internal config

    this.baseUri = '';
    this.authType = AUTH_REQUIRED; // helper to these are available on all requests

    this.AUTH_TYPES = types; // used for validation async token exchange, as per
    // https://getintheloop.atlassian.net/wiki/spaces/DEV/pages/87462238/API+Auth+Token+Exchange

    this.authTokenVersion = -1; // -1 == never set

    this.retryAttempt = 0; // override on a per-request basis

    /**
     * parse a request into object
     * @param  {[type]} json [description]
     * @return {[type]}      [description]
     */

    this.parse = _parse;
    /**
     * Serialize the `data` property for this specific request type
     * @return {Object}  Serialized data as expected by API
     */

    this.serialize = _serialize;
  }

  clone()
  /*: Request*/
  {
    // Minimum effort to not modify the original request data
    const req = new Request(this.path, Object.assign({}, this.data), [].concat(this.fields));
    req.method = this.method;
    req.baseUri = this.baseUri;
    req.authType = this.authType;
    req.parse = this.parse;
    req.serialize = this.serialize;
    req.transform = this.transform;
    req.useCursor = this.useCursor;
    req.useScroll = this.useScroll; // don't copy retryAttempts

    return req;
  }

  url()
  /*: string*/
  {
    // Prevents likely errors. Getting partially-correct urls is likely NOT a use case.
    if (!this.method) throw Error('Calling Request.url() without request.method set is likely an error');
    const d = this.method === 'GET' ? this.serialize(this.data) : {};
    const f = this.fields.length ? this.fields.join(',') : null;
    if (f) d.fields = f;
    const uri = this.baseUri + this.path;
    return withQuery(uri, d);
  }

  jsonBody()
  /*: string*/
  {
    return JSON.stringify(this.serialize(this.data));
  }

  incrementRetries() {
    this.retryAttempt += 1;
  }

}

module.exports = Request;